import "../Common/css/main.css"
import va_logo from "../Assets/Images/va-white.png"
import { useNavigate } from "react-router-dom"

export default function MainPage(){

    const navigate = useNavigate()

    const handleStudent = () => {
        sessionStorage.setItem("userType", "STUDENT")
        handleNavLogin()
    }

    const handleParent = () => {
        sessionStorage.setItem("userType", "PARENT")
        handleNavLogin()
    }
    
    const handleTeacher = () => {
        sessionStorage.setItem("userType", "TEACHER")
        handleNavLogin()
    }

    const handleNavLogin = () => navigate("/login")

    return(
        <div className="mp-outer">
            <div className="mp-overlay"></div>
            <div className="mp-inner">
                <img className="mp-logo" src={va_logo} alt="" />
                <div className="mp-btn-outer">
                    <div className="mp-btns" onClick={handleStudent}>LOGIN AS STUDENT</div>
                    <div className="mp-btns" onClick={handleParent}>LOGIN AS PARENT</div>
                    <div className="mp-btns" onClick={handleTeacher}>LOGIN AS TEACHER</div>
                </div>
            </div>
        </div>
    )
}